import { Users } from "lucide-react";

export const HeadcountBar = ({ total = 0, goal = 20 }) => {
  const pct = Math.min(100, Math.round((total / goal) * 100));
  return (
    <div
      className="mb-8 border-2 border-retro-ink bg-white p-5 shadow-retro-lg"
      data-testid="headcount-bar"
    >
      <div className="mb-3 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <span className="inline-flex items-center justify-center border-2 border-retro-ink bg-retro-yellow p-1.5 shadow-retro-sm">
            <Users className="h-5 w-5 text-retro-ink" />
          </span>
          <span className="font-chango text-lg text-retro-ink" data-testid="headcount-label">
            {total} people are sliding in!
          </span>
        </div>
        <span className="font-chango text-retro-orange">{pct}%</span>
      </div>
      <div className="h-5 w-full overflow-hidden border-2 border-retro-ink bg-retro-cream">
        <div
          className="flex h-full items-center justify-end bg-retro-orange transition-[width] duration-700 ease-out"
          style={{ width: `${Math.max(pct, 4)}%` }}
          data-testid="headcount-progress"
        >
          <span className="pr-2 text-xs font-bold text-white">🌊</span>
        </div>
      </div>
    </div>
  );
};
